// extracted by mini-css-extract-plugin
module.exports = {"cardWidthFix":"StaffEditCard_cardWidthFix__2SMW6","cardContentBorderless":"StaffEditCard_cardContentBorderless__3zpuu","cardContentSpacer":"StaffEditCard_cardContentSpacer__2wu0f"};